import { render, staticRenderFns } from "./userRelational.vue?vue&type=template&id=5425bed0&"
import script from "./userRelational.vue?vue&type=script&lang=js&"
export * from "./userRelational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports